import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';
import { Cluster } from 'pages/complementar/cluster/types';

export function ClusterAutoComplete({
    sx,
    name,
    value,
    error,
    options,
    readOnly,
    disableClearable,
    multiple = false,
    disabled = false,
    onChange = () => {},
    size = 'small',
    label = 'Cluster',
    requestOptions = {
        url: '/gestao/clusterloja',
        sort: [{ property: 'idClusterLoja', direction: 'ASC' }],
        columns: 'idClusterLoja,dsClusterLoja,cdClusterLoja',
        limit: 50,
    },
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            size={size}
            label={label}
            value={value}
            error={error}
            options={options}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            disableClearable={disableClearable}
            requestOptions={requestOptions}
            objectId="idClusterLoja"
            selectedStringTemplate="{dsClusterLoja}"
            optionStringTemplate="{dsClusterLoja}"
            isOptionEqualToValue={(option: Cluster, value: Cluster) => value && option && option.idClusterLoja === value.idClusterLoja}
        />
    );
}
